import { apis } from "../../index";
import { AxiosPromise, AxiosRequestConfig } from "axios";

const BASE_URL = "https://xxl6-bbr3-kxzs.m2.xano.io/api";

const staff_customer = `${BASE_URL}:NcXLAC78/customers/:id`;
const customer_status = `${BASE_URL}:NcXLAC78/customers/status/:id`;
const customer_contacts = `${BASE_URL}:NcXLAC78/getCustomers`;
const get_quote_for_lead = `${BASE_URL}:qyMtgPCE/opp_for_quote`;

// Get Quote for Lead
export type GetQuoteLeadRequestType = Partial<{
  headers: { Authorization: string };
  product_id: string | number;
  contacts_id: string | number;
}>;

export type GetQuoteLeadResponseType = {
  id: number;
  created_at: string;
  product_id: number;
  contacts_id: number;
  _product: {
    id: number;
    name: string;
    subCategory: string;
  };
  _contacts: {
    id: number;
    contactName: string;
  };
};

export const getQuoteforCustomer = (
  payload: AxiosRequestConfig<GetQuoteLeadRequestType>,
): AxiosPromise<GetQuoteLeadResponseType> => {
  const url = `${get_quote_for_lead}`;
  return apis.get(url, {
    ...payload,
    params: {
      ...payload.data,
    },
  });
};

// Get Staff Customer
export type GetStaffCustomerRequestType = Partial<{
  customers_id: string | number;
  headers: { Authorization: string };
}>;

export type GetStaffCustomerResponseType = {
  id: number;
  full_name: string;
  phone_number: string;
  email: string;
  last_kyc: string;
  status: string;
  pan_no: string;
  pan_soft_copy: {
    url: string;
  };
  aadhaar_soft_copy_front: {
    url: string;
  };
  aadhaar_no: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  pincode: string;
  bank_account_number: string;
  bank_name: string;
  ifsc_code: string;
};

export const getStaffCustomer = (
  payload: AxiosRequestConfig<GetStaffCustomerRequestType>,
): AxiosPromise<GetStaffCustomerResponseType> => {
  const customersId = payload.data?.customers_id;

  if (customersId === undefined) {
    throw new Error("customers_id is not provided in the payload.");
  }

  const url = staff_customer.replace(":id", customersId.toString());
  return apis.get(url, payload);
};

// put Customer Status
export type PutCustomerStatusRequestType = Partial<{
  customers_id: string | number;
  status: string;
  headers: { Authorization: string };
}>;

export type PutCustomerStatusResponseType = Partial<{}>;

export const putCustomerStatus = (
  payload: AxiosRequestConfig<PutCustomerStatusRequestType>,
): AxiosPromise<PutCustomerStatusResponseType> => {
  const customersId = payload.data?.customers_id;

  if (customersId === undefined) {
    throw new Error("customers_id is not provided in the payload.");
  }

  const url = customer_status.replace(":id", customersId.toString());
  return apis.put(url, payload);
};

// get customer contacts

export type GetCustomerContactsRequestType = Partial<{
  headers: { Authorization: string };
}>;

export type GetCustomerContactsResponseType = {
  id: string;
  full_name: string;
  email: string;
  phone_number: string;
  pan_no: string;
  aadhaar_no: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  pincode: string;
  state: string;
  country: string;
  kyc_status: string;
  status: string;
}[];

export const getCustomerContacts = (
  payload: AxiosRequestConfig<GetCustomerContactsRequestType>,
): AxiosPromise<GetCustomerContactsResponseType> =>
  apis.get(customer_contacts, payload);
